export interface UserMessage {
  id: number;
  title?: string;
  message: string;
  type: UserMessageType;
  link?: string;
}

export enum UserMessageType {
  success = "success",
  error = "error",
  info = "info"
}
